import { render } from "./ModalEnvioWhatsApp.vue?vue&type=template&id=0640398e"
import script from "./ModalEnvioWhatsApp.vue?vue&type=script&lang=ts"
export * from "./ModalEnvioWhatsApp.vue?vue&type=script&lang=ts"
script.render = render

export default script